<template>
  <div class="footer">
    <div class="row">
      <div class="footer-bd">
        <div class="left-side">
          <p class="tt">包车圈</p>
          <p class="phone">150-5818-4597</p>
          <p class="phone">400-688-1711</p>
          <p class="lb">7×24小时客服电话</p>
        </div>
        <div class="mid-side">
          <div class="list">
            <p class="lb">新手</p>
            <p class="word">NOVICE</p>
            <ul>
              <li>订车常见问题</li>
              <li>包个车平台架构简介</li>
            </ul>
          </div>
          <div class="list">
            <p class="lb">条款</p>
            <p class="word">CALUSE</p>
            <ul>
              <li>服务协议</li>
              <li>包个车平台架构简介</li>
            </ul>
          </div>
          <div class="list">
            <p class="lb">关于我们</p>
            <p class="word">ABOUT US</p>
            <ul>
              <li>关于我们</li>
              <li>联系方式</li>
              <li>平台简介</li>
            </ul>
          </div>
        </div>
        <div class="right-side">
          <img class="qr" :src="QRCodeSrc" alt>
          <p>扫一扫关注微信</p>
        </div>
      </div>
      <div class="footer-ft">
        <p class="copyright">杭州立刻网络科技有限公司 版权所有，禁止非法复制</p>
        <a class="cert" href="javascript:void(0)"></a>
        <a class="cert" href="javascript:void(0)"></a>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from '@/assets/images/erweima.jpg'
export default {
  data() {
    return {
      QRCodeSrc: qrcode,
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  min-width: 1200px;
  height: @footerHeight;
  padding-top: 50px;
  box-sizing: border-box;
  background-color: #272727;
  color: #959595;
  .row {
    width: 1200px;
    margin: 0 auto;
  }
  .footer-bd {
    overflow: auto;
    padding-bottom: 20px;
    border-bottom: 1px solid #464646;
    margin-bottom: 20px;
    .left-side {
      width: 27%;
      .tt {
        font-size: 32px;
        color: #fff;
        font-weight: bold;
      }
      .phone {
        color: #ffe200;
        font-size: 24px;
        font-weight: bold;
      }
      .lb {
        color: #999;
      }
      .tt,
      .phone,
      .lb {
        margin-bottom: 10px;
      }
    }
    .mid-side {
      width: 45%;
      .list {
        float: left;
        width: 33.33%;
      }
      .lb {
        font-size: 14px;
        color: #dadada;
        margin-bottom: 10px;
      }
      .word {
        font-size: 12px;
        color: #3d3d3d;
      }
      .word,
      ul li {
        margin-bottom: 20px;
      }
    }
    .right-side {
      width: 28%;
      border-left: 1px solid #464646;
      box-sizing: border-box;
      text-align: center;
      .qr {
        width: 120px;
        height: 120px;
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 25px;
      }
    }
    .left-side,
    .mid-side,
    .right-side {
      float: left;
    }
  }
  .footer-ft {
    .copyright {
      float: left;
      margin-top: 20px;
    }
    .cert {
      float: right;
    }
    .cert:first-of-type {
      width: 124px;
      height: 47px;
      .bgImage('cert.png';2)
    }
    .cert:nth-of-type(2) {
      width: 82px;
      height: 32px;
      .bgImage('jiance.jpg';2);
      margin-top: 15px;
      margin-right: 25px;
    }
  }
}
</style>